import { render, staticRenderFns } from "./data44.vue?vue&type=template&id=12ebc8c2&scoped=true"
import script from "./data44.vue?vue&type=script&lang=js"
export * from "./data44.vue?vue&type=script&lang=js"
import style1 from "./data44.vue?vue&type=style&index=1&id=12ebc8c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ebc8c2",
  null
  
)

export default component.exports